import { render, staticRenderFns } from "./proposedDocumentListEdit.vue?vue&type=template&id=34cffae8&"
import script from "./proposedDocumentListEdit.vue?vue&type=script&lang=js&"
export * from "./proposedDocumentListEdit.vue?vue&type=script&lang=js&"
import style0 from "./proposedDocumentListEdit.vue?vue&type=style&index=0&id=34cffae8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports